var map = {
	"./css/main.css": "5aea",
	"./img/facebook-f.svg": "8a74",
	"./img/linkedin-in.svg": "c25f",
	"./img/ndalegal-folder.jpg": "77c9",
	"./img/ndalegal-logo.svg": "fffd",
	"./img/specialities/adatvedelem.png": "3331",
	"./img/specialities/background.svg": "2903",
	"./img/specialities/digitalis-gazdasagi-jog.png": "5b6a",
	"./img/specialities/informatikai-es-szerzoi-jog.png": "d4af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";